import { HTTP } from '@/services/axios';

export async function getProjects({filterText,orderCol,orderSort,page,records}){
    let result = {};
    
    await HTTP.get('/app/customWorking/WorkingProjects/getProjectList.php',{
        params:{
            filterText,
            orderCol,
            orderSort,
            page,
            records
        }
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getProject({projectId}){
    let result = {};
   
    await HTTP({
        method: 'get',
        url: `/app/customWorking/WorkingProjects/getProjectData.php?projectId=${projectId}`,
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getProjectOptions(){
    let result = {};
   
    await HTTP({
        method: 'get',
        url: '/app/customWorking/WorkingProjects/getProjectOptions.php'
    })
    .then(response => {
        result = response.data.result;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function unlockProject({projectId}){
    let result = {};

    var data = {'myRecordID':projectId};
    
    await HTTP({
        method: 'patch',
        url: '/app/customWorking/WorkingProjects/controlProjectUnlock.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function changeStateProject({projectId,state}){
    let result = {};

    var data = {'projectId':projectId,'state':state}
    
    await HTTP({
        method: 'patch',
        url: '/app/customWorking/WorkingProjects/controlProjectChangeState.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function createProject(data){
    let result = {};

    await HTTP({
        method: 'post',
        url: '/app/customWorking/WorkingProjects/controlProjectSave.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function saveProject(data){
    let result = {};

    await HTTP({
        method: 'put',
        url: '/app/customWorking/WorkingProjects/controlProjectSave.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function deleteProject(data){
    let result = {};
   
    await HTTP({
        method: 'delete',
        url: '/app/customWorking/WorkingProjects/controlProjectDelete.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}


// sprava fotiek k projektu
export async function getDataToUploadPhoto({projectId}){
    let result = {};
   
    await HTTP({
        method: 'get',
        url: `/app/customWorking/WorkingProjects/projectPhotoUpload/getDataToUpload.php?projectId=${projectId}`
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export function uploadPhotoUrl(){
    return "/app/customWorking/WorkingProjects/projectPhotoUpload/controlPhotoUpload.php";
}

export async function getProjectPhotos({projectId}){
    let result = {};
   
    await HTTP({
        method: 'get',
        url: `/app/customWorking/WorkingProjects/projectPhoto/getProjectPhotoPreviewData.php?projectId=${projectId}`
    })
    .then(response => {
        console.log(response.data)
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function rotatePhoto({photoId}){
    let result = {};

    var data = {'photoId':photoId}
    
    await HTTP({
        method: 'patch',
        url: '/app/customWorking/WorkingProjects/projectPhoto/controlPhotoRotate.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function deletePhoto({photoId}){
    let result = {};

    var data = {'photoId':photoId}

    await HTTP({
        method: 'delete',
        url: '/app/customWorking/WorkingProjects/projectPhoto/controlPhotoDelete.php',
        data: data
    })
    .then(response => {
        console.log(response.data)
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function setDefaultPhotoToProject({photoId,projectId}){
    let result = {};

    var data = {'photoId':photoId,'projectId':projectId}
    
    await HTTP({
        method: 'patch',
        url: '/app/customWorking/WorkingProjects/projectPhoto/controlPhotoSelectMain.php',
        data: data
    })
    .then(response => {
        console.log(response.data)
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}